let NetInfoPackage;
try {
  NetInfoPackage = require('@react-native-community/netinfo');
} catch (error) {}
export default NetInfoPackage;